// TiktokPost + TitkokAccount i18n fragment
const fragment = {
  vi: {
    // tiktokPost (list)
    'ttPost.tiktokPost.title': 'Bài viết TikTok',
    'ttPost.tiktokPost.create': 'Tạo bài viết',
    'ttPost.tiktokPost.searchLabel': 'Tìm kiếm',
    'ttPost.tiktokPost.searchPlaceholder': 'Tìm theo tiêu đề / mô tả',
    'ttPost.tiktokPost.accountLabel': 'Tài khoản',
    'ttPost.tiktokPost.allAccounts': 'Tất cả tài khoản',
    'ttPost.tiktokPost.statusLabel': 'Trạng thái',
    'ttPost.tiktokPost.filter': 'Lọc',
    'ttPost.tiktokPost.reset': 'Đặt lại',
    'ttPost.tiktokPost.statusAll': 'Tất cả trạng thái',
    'ttPost.tiktokPost.statusDraft': 'Nháp',
    'ttPost.tiktokPost.statusScheduled': 'Đã lên lịch',
    'ttPost.tiktokPost.statusPublished': 'Đã đăng',
    'ttPost.tiktokPost.statusFailed': 'Lỗi',
    'ttPost.tiktokPost.tabAll': 'Tất cả',

    // tiktokPost table
    'ttPost.table.badgePublished': 'Đã đăng',
    'ttPost.table.badgeFailed': 'Lỗi',
    'ttPost.table.badgeScheduled': 'Đã lên lịch',
    'ttPost.table.badgeProcessing': 'Đang đăng',
    'ttPost.table.badgeDraft': 'Nháp',
    'ttPost.table.privacyPublic': 'Công khai',
    'ttPost.table.privacyFriends': 'Bạn bè',
    'ttPost.table.privacyFollowers': 'Followers',
    'ttPost.table.privacyPrivate': 'Riêng tư',
    'ttPost.table.waitingCron': 'Đang chờ cron xử lý',
    'ttPost.table.publishing': 'Đang đăng…',
    'ttPost.table.selectTime': 'Vui lòng chọn thời gian.',
    'ttPost.table.minLead': 'Thời gian đăng phải cách hiện tại ít nhất {minutes} phút.',
    'ttPost.table.reschedule': 'Đổi giờ đăng',
    'ttPost.table.pickNewDate': 'Chọn ngày giờ mới',
    'ttPost.table.minLeadHint': 'Cách hiện tại tối thiểu {minutes} phút.',
    'ttPost.table.cancel': 'Huỷ',
    'ttPost.table.saveSchedule': 'Lưu lịch',
    'ttPost.table.deleteTitle': 'Xoá bài viết?',
    'ttPost.table.deleteDesc': 'Bài viết sẽ bị xoá khỏi hệ thống. Bài đã đăng trên TikTok vẫn còn.',
    'ttPost.table.deleteConfirm': 'Xoá',
    'ttPost.table.deleteSuccess': 'Đã xoá bài viết.',
    'ttPost.table.publishScheduledTitle': 'Đăng ngay bài đã lên lịch?',
    'ttPost.table.publishScheduledDesc':
      'Lịch đăng tự động sẽ bị huỷ và bài sẽ được đăng ngay lập tức.',
    'ttPost.table.publishNowConfirm': 'Đăng ngay',
    'ttPost.table.publishSuccess': 'Đăng bài thành công.',
    'ttPost.table.publishFailed': 'Đăng bài thất bại.',
    'ttPost.table.retrySuccess': 'Đã thử đăng lại.',
    'ttPost.table.retryFailed': 'Thử lại thất bại.',
    'ttPost.table.rescheduleSuccess': 'Đã cập nhật lịch đăng.',
    'ttPost.table.rescheduleFailed': 'Cập nhật lịch thất bại.',
    'ttPost.table.cancelScheduleTitle': 'Huỷ lịch đăng?',
    'ttPost.table.cancelScheduleDesc': 'Bài sẽ chuyển về trạng thái Nháp.',
    'ttPost.table.cancelScheduleConfirm': 'Huỷ lịch',
    'ttPost.table.cancelScheduleSuccess': 'Đã huỷ lịch đăng.',
    'ttPost.table.colAccount': 'Tài khoản',
    'ttPost.table.colContent': 'Nội dung',
    'ttPost.table.colMedia': 'Media',
    'ttPost.table.colPrivacy': 'Quyền',
    'ttPost.table.colStatus': 'Trạng thái',
    'ttPost.table.colTime': 'Thời gian',
    'ttPost.table.colLink': 'Link bài',
    'ttPost.table.colCreatedAt': 'Tạo lúc',
    'ttPost.table.colAction': 'Thao tác',
    'ttPost.table.copyLink': 'Sao chép link',
    'ttPost.table.viewOnTiktok': 'Xem trên TikTok',
    'ttPost.table.cancelSchedule': 'Huỷ lịch đăng',
    'ttPost.table.retry': 'Thử đăng lại',
    'ttPost.table.publishNow': 'Đăng ngay',
    'ttPost.table.edit': 'Sửa bài viết',
    'ttPost.table.delete': 'Xoá bài viết',
    'ttPost.table.emptyTitle': 'Chưa có bài viết',
    'ttPost.table.emptyDesc': 'Tạo bài viết đầu tiên để đăng lên TikTok',

    // titkokAccount (list)
    'ttAcc.titkokAccount.title': 'Tài khoản Tiktok',
    'ttAcc.titkokAccount.connect': 'Kết nối TikTok',
    'ttAcc.titkokAccount.searchLabel': 'Tìm kiếm tài khoản',
    'ttAcc.titkokAccount.search': 'Tìm kiếm',
    'ttAcc.titkokAccount.reset': 'Đặt lại',

    // videos
    'ttAcc.videos.back': 'Quay lại',
    'ttAcc.videos.titleWithName': 'Video TikTok của {name}',
    'ttAcc.videos.fetchedVia': 'Lấy trực tiếp từ TikTok Display API qua scope',
    'ttAcc.videos.title': 'Video TikTok',
    'ttAcc.videos.refresh': 'Làm mới',
    'ttAcc.videos.openProfile': 'Mở profile',
    'ttAcc.videos.loadFailed': 'Không tải được danh sách video.',
    'ttAcc.videos.tokenExpired': 'Có thể access token đã hết hạn. Hãy kết nối lại TikTok.',
    'ttAcc.videos.emptyTitle': 'Tài khoản chưa có video',
    'ttAcc.videos.emptyDesc': 'Khi bạn đăng video lên TikTok, danh sách sẽ hiển thị ở đây.',
    'ttAcc.videos.noDescription': '(Không có mô tả)',
    'ttAcc.videos.openOnTiktok': 'Mở trên TikTok',
    'ttAcc.videos.pageCount': '{count} video trang này',
    'ttAcc.videos.loadingSuffix': ' (đang tải...)',
    'ttAcc.videos.prevPage': 'Trang trước',
    'ttAcc.videos.nextPage': 'Trang sau',
    'ttAcc.videos.loadMore': 'Tải thêm',
    'ttAcc.videos.filterPlaceholder': 'Lọc theo tiêu đề / mô tả...',
    'ttAcc.videos.showing': 'Hiển thị {shown}/{total} video',
    'ttAcc.videos.noMatch': 'Không có video khớp bộ lọc',

    // accountDetail
    'ttAcc.accountDetail.badgePublished': 'Đã đăng',
    'ttAcc.accountDetail.badgeFailed': 'Lỗi',
    'ttAcc.accountDetail.badgeScheduled': 'Đã lên lịch',
    'ttAcc.accountDetail.badgeProcessing': 'Đang đăng',
    'ttAcc.accountDetail.badgeDraft': 'Nháp',
    'ttAcc.accountDetail.syncSuccess': 'Đã đồng bộ profile từ TikTok.',
    'ttAcc.accountDetail.syncFailed': 'Đồng bộ thất bại.',
    'ttAcc.accountDetail.notFound': 'Không tìm thấy tài khoản.',
    'ttAcc.accountDetail.active': 'Đang hoạt động',
    'ttAcc.accountDetail.disabled': 'Đã tắt',
    'ttAcc.accountDetail.tokenExpired': 'Token đã hết hạn',
    'ttAcc.accountDetail.statFollowers': 'Followers',
    'ttAcc.accountDetail.statFollowing': 'Following',
    'ttAcc.accountDetail.statLikes': 'Likes',
    'ttAcc.accountDetail.statVideo': 'Video',
    'ttAcc.accountDetail.statPosts24h': 'Bài /24h',
    'ttAcc.accountDetail.openOnTiktok': 'Mở trên TikTok',
    'ttAcc.accountDetail.createPost': 'Tạo bài viết',
    'ttAcc.accountDetail.viewVideos': 'Xem video trên TikTok',
    'ttAcc.accountDetail.syncProfile': 'Đồng bộ profile',
    'ttAcc.accountDetail.renameDisplay': 'Đổi tên hiển thị',
    'ttAcc.accountDetail.back': '← Quay lại',
    'ttAcc.accountDetail.syncedAt': 'Đồng bộ {time}',
    'ttAcc.accountDetail.recentPosts': 'Bài viết gần đây trên hệ thống',
    'ttAcc.accountDetail.recentPostsSub': 'Bài đã tạo qua BPS cho tài khoản này',
    'ttAcc.accountDetail.emptyTitle': 'Chưa có bài viết nào',
    'ttAcc.accountDetail.emptyDesc': 'Bấm "Tạo bài viết" để bắt đầu đăng video TikTok đầu tiên.',
    'ttAcc.accountDetail.noDescription': '(Không có mô tả)',

    // createModal
    'ttAcc.createModal.saveSuccess': '{action} dữ liệu thành công',
    'ttAcc.createModal.actionUpdate': 'Cập nhật',
    'ttAcc.createModal.actionCreate': 'Tạo',
    'ttAcc.createModal.titleCreate': 'Tạo tài khoản Tiktok',
    'ttAcc.createModal.titleEdit': 'Chỉnh sửa tài khoản Tiktok',
    'ttAcc.createModal.fieldName': 'Tên tài khoản',
    'ttAcc.createModal.fieldUsername': 'Tên người dùng',
    'ttAcc.createModal.fieldCookie': 'Cookie',
    'ttAcc.createModal.cancel': 'Hủy',
    'ttAcc.createModal.submitCreate': 'Tạo',
    'ttAcc.createModal.submitEdit': 'Chỉnh sửa',

    // titkokAccount table
    'ttAcc.table.changeStatusSuccess': 'Đã thay đổi trạng thái tài khoản',
    'ttAcc.table.changeStatusFailed': 'Thay đổi trạng thái tài khoản thất bại',
    'ttAcc.table.deleteTitle': 'Xoá tài khoản TikTok?',
    'ttAcc.table.deleteDesc': 'Hành động này không thể hoàn tác. Bạn có chắc chắn?',
    'ttAcc.table.deleteConfirm': 'Xoá',
    'ttAcc.table.deleteSuccess': 'Xóa tài khoản thành công',
    'ttAcc.table.copyUserId': 'Đã sao chép user id.',
    'ttAcc.table.colAccount': 'Tài khoản',
    'ttAcc.table.colStatus': 'Trạng thái',
    'ttAcc.table.colCreatedAt': 'Ngày tạo',
    'ttAcc.table.colAction': 'Thao tác',
    'ttAcc.table.noUsername': 'chưa có username',
    'ttAcc.table.openProfile': 'Mở profile trên TikTok',
    'ttAcc.table.openProfileAria': 'Mở profile TikTok',
    'ttAcc.table.update': 'Cập nhật tài khoản',
    'ttAcc.table.viewDetail': 'Xem chi tiết',
    'ttAcc.table.delete': 'Xóa tài khoản',
    'ttAcc.table.emptyTitle': 'Chưa có dữ liệu',
    'ttAcc.table.emptyDesc': 'Hãy thêm bản ghi đầu tiên để bắt đầu',

    // tiktokAccountForm
    'ttAcc.tiktokAccountForm.update': 'Cập nhật',
    'ttAcc.tiktokAccountForm.finishConnect': 'Hoàn tất kết nối',
    'ttAcc.tiktokAccountForm.loginHint':
      'Bấm nút bên dưới để mở cửa sổ đăng nhập TikTok. Sau khi xác thực, hệ thống sẽ tự động trở về và điền thông tin tài khoản.',
    'ttAcc.tiktokAccountForm.login': 'Đăng nhập TikTok',
    'ttAcc.tiktokAccountForm.rejected': 'TikTok từ chối: {error}',
    'ttAcc.tiktokAccountForm.alreadyConnected': 'Tài khoản TikTok này đã được kết nối trước đó.',
    'ttAcc.tiktokAccountForm.authSuccess': 'Xác thực TikTok thành công.',
    'ttAcc.tiktokAccountForm.authFailed': 'Xác thực TikTok thất bại.',
    'ttAcc.tiktokAccountForm.missingClientKey': 'Thiếu cấu hình TIKTOK_CLIENT_KEY ở FE .env',
    'ttAcc.tiktokAccountForm.updateSuccess': 'Cập nhật tài khoản thành công.',
    'ttAcc.tiktokAccountForm.updateFailed': 'Cập nhật thất bại.',
    'ttAcc.tiktokAccountForm.loginFirst': 'Vui lòng đăng nhập TikTok trước.',
    'ttAcc.tiktokAccountForm.connectSuccess': 'Kết nối tài khoản thành công.',
    'ttAcc.tiktokAccountForm.connectFailed': 'Kết nối thất bại.',
    'ttAcc.tiktokAccountForm.titleEdit': 'Cập nhật tài khoản TikTok',
    'ttAcc.tiktokAccountForm.titleCreate': 'Kết nối tài khoản TikTok',
    'ttAcc.tiktokAccountForm.subtitleEdit': 'Đổi tên hiển thị cho tài khoản này.',
    'ttAcc.tiktokAccountForm.subtitleCreate': 'Đăng nhập TikTok để cấp quyền upload video.',
    'ttAcc.tiktokAccountForm.authenticating': 'Đang xác thực với TikTok...',
    'ttAcc.tiktokAccountForm.followers': 'followers',
    'ttAcc.tiktokAccountForm.video': 'video',
    'ttAcc.tiktokAccountForm.scope': 'Scope: {scope}',
    'ttAcc.tiktokAccountForm.labelDisplayName': 'Tên hiển thị (BO)',
    'ttAcc.tiktokAccountForm.placeholderDisplayName': 'Ví dụ: TikTok Marketing',
    'ttAcc.tiktokAccountForm.labelTiktokName': 'Tên TikTok',
    'ttAcc.tiktokAccountForm.labelUsername': 'Username',
    'ttAcc.tiktokAccountForm.labelOpenId': 'Open ID',
    'ttAcc.tiktokAccountForm.cancel': 'Hủy',
  },
  en: {
    // tiktokPost (list)
    'ttPost.tiktokPost.title': 'TikTok Posts',
    'ttPost.tiktokPost.create': 'Create post',
    'ttPost.tiktokPost.searchLabel': 'Search',
    'ttPost.tiktokPost.searchPlaceholder': 'Search by title / description',
    'ttPost.tiktokPost.accountLabel': 'Account',
    'ttPost.tiktokPost.allAccounts': 'All accounts',
    'ttPost.tiktokPost.statusLabel': 'Status',
    'ttPost.tiktokPost.filter': 'Filter',
    'ttPost.tiktokPost.reset': 'Reset',
    'ttPost.tiktokPost.statusAll': 'All statuses',
    'ttPost.tiktokPost.statusDraft': 'Draft',
    'ttPost.tiktokPost.statusScheduled': 'Scheduled',
    'ttPost.tiktokPost.statusPublished': 'Published',
    'ttPost.tiktokPost.statusFailed': 'Failed',
    'ttPost.tiktokPost.tabAll': 'All',

    // tiktokPost table
    'ttPost.table.badgePublished': 'Published',
    'ttPost.table.badgeFailed': 'Failed',
    'ttPost.table.badgeScheduled': 'Scheduled',
    'ttPost.table.badgeProcessing': 'Publishing',
    'ttPost.table.badgeDraft': 'Draft',
    'ttPost.table.privacyPublic': 'Public',
    'ttPost.table.privacyFriends': 'Friends',
    'ttPost.table.privacyFollowers': 'Followers',
    'ttPost.table.privacyPrivate': 'Private',
    'ttPost.table.waitingCron': 'Waiting for cron to process',
    'ttPost.table.publishing': 'Publishing…',
    'ttPost.table.selectTime': 'Please pick a time.',
    'ttPost.table.minLead': 'Publish time must be at least {minutes} minutes from now.',
    'ttPost.table.reschedule': 'Change schedule',
    'ttPost.table.pickNewDate': 'Pick a new date & time',
    'ttPost.table.minLeadHint': 'At least {minutes} minutes from now.',
    'ttPost.table.cancel': 'Cancel',
    'ttPost.table.saveSchedule': 'Save schedule',
    'ttPost.table.deleteTitle': 'Delete post?',
    'ttPost.table.deleteDesc':
      'The post will be removed from the system. Posts already published on TikTok remain.',
    'ttPost.table.deleteConfirm': 'Delete',
    'ttPost.table.deleteSuccess': 'Post deleted.',
    'ttPost.table.publishScheduledTitle': 'Publish scheduled post now?',
    'ttPost.table.publishScheduledDesc':
      'The auto schedule will be cancelled and the post will be published immediately.',
    'ttPost.table.publishNowConfirm': 'Publish now',
    'ttPost.table.publishSuccess': 'Post published successfully.',
    'ttPost.table.publishFailed': 'Failed to publish post.',
    'ttPost.table.retrySuccess': 'Retried publishing.',
    'ttPost.table.retryFailed': 'Retry failed.',
    'ttPost.table.rescheduleSuccess': 'Schedule updated.',
    'ttPost.table.rescheduleFailed': 'Failed to update schedule.',
    'ttPost.table.cancelScheduleTitle': 'Cancel schedule?',
    'ttPost.table.cancelScheduleDesc': 'The post will return to Draft status.',
    'ttPost.table.cancelScheduleConfirm': 'Cancel schedule',
    'ttPost.table.cancelScheduleSuccess': 'Schedule cancelled.',
    'ttPost.table.colAccount': 'Account',
    'ttPost.table.colContent': 'Content',
    'ttPost.table.colMedia': 'Media',
    'ttPost.table.colPrivacy': 'Privacy',
    'ttPost.table.colStatus': 'Status',
    'ttPost.table.colTime': 'Time',
    'ttPost.table.colLink': 'Post link',
    'ttPost.table.colCreatedAt': 'Created at',
    'ttPost.table.colAction': 'Actions',
    'ttPost.table.copyLink': 'Copy link',
    'ttPost.table.viewOnTiktok': 'View on TikTok',
    'ttPost.table.cancelSchedule': 'Cancel schedule',
    'ttPost.table.retry': 'Retry publishing',
    'ttPost.table.publishNow': 'Publish now',
    'ttPost.table.edit': 'Edit post',
    'ttPost.table.delete': 'Delete post',
    'ttPost.table.emptyTitle': 'No posts yet',
    'ttPost.table.emptyDesc': 'Create your first post to publish on TikTok',

    // titkokAccount (list)
    'ttAcc.titkokAccount.title': 'TikTok Accounts',
    'ttAcc.titkokAccount.connect': 'Connect TikTok',
    'ttAcc.titkokAccount.searchLabel': 'Search account',
    'ttAcc.titkokAccount.search': 'Search',
    'ttAcc.titkokAccount.reset': 'Reset',

    // videos
    'ttAcc.videos.back': 'Back',
    'ttAcc.videos.titleWithName': "{name}'s TikTok videos",
    'ttAcc.videos.fetchedVia': 'Fetched directly from the TikTok Display API via scope',
    'ttAcc.videos.title': 'TikTok videos',
    'ttAcc.videos.refresh': 'Refresh',
    'ttAcc.videos.openProfile': 'Open profile',
    'ttAcc.videos.loadFailed': 'Failed to load video list.',
    'ttAcc.videos.tokenExpired': 'The access token may have expired. Please reconnect TikTok.',
    'ttAcc.videos.emptyTitle': 'No videos on this account',
    'ttAcc.videos.emptyDesc': 'Once you post videos to TikTok, they will appear here.',
    'ttAcc.videos.noDescription': '(No description)',
    'ttAcc.videos.openOnTiktok': 'Open on TikTok',
    'ttAcc.videos.pageCount': '{count} videos on this page',
    'ttAcc.videos.loadingSuffix': ' (loading...)',
    'ttAcc.videos.prevPage': 'Previous',
    'ttAcc.videos.nextPage': 'Next',
    'ttAcc.videos.loadMore': 'Load more',
    'ttAcc.videos.filterPlaceholder': 'Filter by title / description...',
    'ttAcc.videos.showing': 'Showing {shown}/{total} videos',
    'ttAcc.videos.noMatch': 'No videos match the filter',

    // accountDetail
    'ttAcc.accountDetail.badgePublished': 'Published',
    'ttAcc.accountDetail.badgeFailed': 'Failed',
    'ttAcc.accountDetail.badgeScheduled': 'Scheduled',
    'ttAcc.accountDetail.badgeProcessing': 'Publishing',
    'ttAcc.accountDetail.badgeDraft': 'Draft',
    'ttAcc.accountDetail.syncSuccess': 'Profile synced from TikTok.',
    'ttAcc.accountDetail.syncFailed': 'Sync failed.',
    'ttAcc.accountDetail.notFound': 'Account not found.',
    'ttAcc.accountDetail.active': 'Active',
    'ttAcc.accountDetail.disabled': 'Disabled',
    'ttAcc.accountDetail.tokenExpired': 'Token expired',
    'ttAcc.accountDetail.statFollowers': 'Followers',
    'ttAcc.accountDetail.statFollowing': 'Following',
    'ttAcc.accountDetail.statLikes': 'Likes',
    'ttAcc.accountDetail.statVideo': 'Video',
    'ttAcc.accountDetail.statPosts24h': 'Posts /24h',
    'ttAcc.accountDetail.openOnTiktok': 'Open on TikTok',
    'ttAcc.accountDetail.createPost': 'Create post',
    'ttAcc.accountDetail.viewVideos': 'View videos on TikTok',
    'ttAcc.accountDetail.syncProfile': 'Sync profile',
    'ttAcc.accountDetail.renameDisplay': 'Rename display name',
    'ttAcc.accountDetail.back': '← Back',
    'ttAcc.accountDetail.syncedAt': 'Synced {time}',
    'ttAcc.accountDetail.recentPosts': 'Recent posts in the system',
    'ttAcc.accountDetail.recentPostsSub': 'Posts created via BPS for this account',
    'ttAcc.accountDetail.emptyTitle': 'No posts yet',
    'ttAcc.accountDetail.emptyDesc': 'Click "Create post" to publish your first TikTok video.',
    'ttAcc.accountDetail.noDescription': '(No description)',

    // createModal
    'ttAcc.createModal.saveSuccess': '{action} data successfully',
    'ttAcc.createModal.actionUpdate': 'Update',
    'ttAcc.createModal.actionCreate': 'Create',
    'ttAcc.createModal.titleCreate': 'Create TikTok account',
    'ttAcc.createModal.titleEdit': 'Edit TikTok account',
    'ttAcc.createModal.fieldName': 'Account name',
    'ttAcc.createModal.fieldUsername': 'Username',
    'ttAcc.createModal.fieldCookie': 'Cookie',
    'ttAcc.createModal.cancel': 'Cancel',
    'ttAcc.createModal.submitCreate': 'Create',
    'ttAcc.createModal.submitEdit': 'Edit',

    // titkokAccount table
    'ttAcc.table.changeStatusSuccess': 'Account status changed',
    'ttAcc.table.changeStatusFailed': 'Failed to change account status',
    'ttAcc.table.deleteTitle': 'Delete TikTok account?',
    'ttAcc.table.deleteDesc': 'This action cannot be undone. Are you sure?',
    'ttAcc.table.deleteConfirm': 'Delete',
    'ttAcc.table.deleteSuccess': 'Account deleted successfully',
    'ttAcc.table.copyUserId': 'User id copied.',
    'ttAcc.table.colAccount': 'Account',
    'ttAcc.table.colStatus': 'Status',
    'ttAcc.table.colCreatedAt': 'Created date',
    'ttAcc.table.colAction': 'Actions',
    'ttAcc.table.noUsername': 'no username yet',
    'ttAcc.table.openProfile': 'Open profile on TikTok',
    'ttAcc.table.openProfileAria': 'Open TikTok profile',
    'ttAcc.table.update': 'Update account',
    'ttAcc.table.viewDetail': 'View detail',
    'ttAcc.table.delete': 'Delete account',
    'ttAcc.table.emptyTitle': 'No data yet',
    'ttAcc.table.emptyDesc': 'Add your first record to get started',

    // tiktokAccountForm
    'ttAcc.tiktokAccountForm.update': 'Update',
    'ttAcc.tiktokAccountForm.finishConnect': 'Finish connecting',
    'ttAcc.tiktokAccountForm.loginHint':
      'Click the button below to open the TikTok login window. After authenticating, you will be returned automatically and the account info will be filled in.',
    'ttAcc.tiktokAccountForm.login': 'Sign in with TikTok',
    'ttAcc.tiktokAccountForm.rejected': 'TikTok rejected: {error}',
    'ttAcc.tiktokAccountForm.alreadyConnected': 'This TikTok account has already been connected.',
    'ttAcc.tiktokAccountForm.authSuccess': 'TikTok authentication successful.',
    'ttAcc.tiktokAccountForm.authFailed': 'TikTok authentication failed.',
    'ttAcc.tiktokAccountForm.missingClientKey': 'Missing TIKTOK_CLIENT_KEY config in FE .env',
    'ttAcc.tiktokAccountForm.updateSuccess': 'Account updated successfully.',
    'ttAcc.tiktokAccountForm.updateFailed': 'Update failed.',
    'ttAcc.tiktokAccountForm.loginFirst': 'Please sign in with TikTok first.',
    'ttAcc.tiktokAccountForm.connectSuccess': 'Account connected successfully.',
    'ttAcc.tiktokAccountForm.connectFailed': 'Connection failed.',
    'ttAcc.tiktokAccountForm.titleEdit': 'Update TikTok account',
    'ttAcc.tiktokAccountForm.titleCreate': 'Connect TikTok account',
    'ttAcc.tiktokAccountForm.subtitleEdit': 'Rename the display name for this account.',
    'ttAcc.tiktokAccountForm.subtitleCreate':
      'Sign in with TikTok to grant video upload permission.',
    'ttAcc.tiktokAccountForm.authenticating': 'Authenticating with TikTok...',
    'ttAcc.tiktokAccountForm.followers': 'followers',
    'ttAcc.tiktokAccountForm.video': 'videos',
    'ttAcc.tiktokAccountForm.scope': 'Scope: {scope}',
    'ttAcc.tiktokAccountForm.labelDisplayName': 'Display name (BO)',
    'ttAcc.tiktokAccountForm.placeholderDisplayName': 'e.g. TikTok Marketing',
    'ttAcc.tiktokAccountForm.labelTiktokName': 'TikTok name',
    'ttAcc.tiktokAccountForm.labelUsername': 'Username',
    'ttAcc.tiktokAccountForm.labelOpenId': 'Open ID',
    'ttAcc.tiktokAccountForm.cancel': 'Cancel',
  },
};

export default fragment;
